export const marketingHeadingStyles = {
  h1: { fontFamily: 'var(--telivi-font-heading)' },
  h2: { fontFamily: 'var(--telivi-font-heading)' },
  h3: { fontFamily: 'var(--telivi-font-heading)' },
};
